import { useState } from "react";
import { Link } from "react-router-dom";
import PopupLightbox from "../components/PopupLightbox";

import imgCloseIcon from "../images/icon-close.png";

// import anon from "../images/bio/anonymous.png";
import masashiro from "../images/bio/masashiro.jpg";
import sarahJ from "../images/bio/sarahJ.jpg";

const StudentHighlights = () => {
  const [buttonPopup1, setButtonPopup1] = useState(false);
  const [buttonPopup2, setButtonPopup2] = useState(false);

  return (
    <div className="grid-container dark-bg">
      <div className="popup-wrapper">
        <div className="popup-col colB">
          <div className="popup-col-inner">
            <h2>Student Highlights</h2>
            <Link className="close-btn" to="/">
              <img src={imgCloseIcon} alt="close button" />
            </Link>

            <ul className="circle-container">
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${sarahJ})` }}
                  onClick={() => setButtonPopup1(true)}
                >
                  <span>Sara Jane Tate</span>
                </button>
              </li>
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${masashiro})` }}
                  onClick={() => setButtonPopup2(true)}
                >
                  <span>Masahiro Hokazono</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <PopupLightbox trigger={buttonPopup1} setTrigger={setButtonPopup1} columnPosition="colB">
        <h3>Sara Jane Tate</h3>

        <h4 className="headingSpacer">Headaches, Heartbreaks, and Helping Hands</h4>

        <p>
          When Sarah Jane Tate first started the accounting junior core at the BYU Marriott School of Business, she had
          no idea she'd have to navigate a concussion, a new job, and a broken engagement to make it through the school
          year.
        </p>

        <p>
          At the start of college, Tate thought her career path was clear: She'd become an accountant , just like her
          dad. “It's hereditary, I guess,” she says. “I've always really liked math and numbers, so I took Accounting
          200, and I was like, 'Yep, this is it. This is the one.'”
        </p>

        <p>
          Then, during her first semester in the program, Tate fell down a staircase. She tried to push through a
          persistent headache, but focusing on her classes became increasingly difficult. “I knew I couldn't take
          incredibly complicated midterms.” She went to the doctor and was diagnosed with a concussion.
        </p>

        <p>
          Not wanting to fall behind, Tate worked with her professors and an academic advisor to make a contractual
          arrangement to complete her coursework within a year. She also secured an internship for the upcoming summer
          at Breeze, where her soon-to-be mother-in-law worked. And then the unexpected hit: She and her fiancé broke up
          just two weeks before their wedding.
        </p>

        <p>
          “It was a lot,” she admits. “I was going through a concussion and had these incomplete course contracts; I was
          trying to catch up on everything I'd missed, while I was also planning a wedding — which then I had to
          cancel.”
        </p>

        <p>
          Tate began the winter semester courses for the junior core still scrambling to catch up on her incomplete work
          from fall semester. “I had an intro tax class, and two days into the semester, I was sitting there staring at
          the tax textbook for four hours, not getting a single word,” she says. “My brain was just not ready.” So, she
          returned to her school counselors and worked with them to find another way to move forward while she healed.
        </p>

        <p>
          With their guidance, she registered for classes traditionally taken in the MAcc program. These classes—while
          not easy—were much less dependent on memorization than the courses in the junior core. Tate was able to
          complete her winter coursework while maintaining her scholarship.
        </p>

        <p>
          Finally recovered from her concussion, Tate finished her first year in the accounting program, the deadline to
          complete her coursework from the first semester coming ever closer. The time came for her to begin her
          internship at Breeze Airways, and she felt apprehensive to start working.
        </p>

        <p>
          Then, on her first day, she ran into the company's CFO in the elevator. “He literally has remembered my name
          ever since, because all of the executive officers are just really awesome and personable,” she says. She felt
          her apprehension dissipate, and she enjoyed her time at the company as an intern.
        </p>

        <p>
          When the fall semester came around, Tate continued working at Breeze part-time. With great relief, she
          finished everything she needed to get credit for her junior core classes and started the next set of
          accounting classes alongside the courses for her double-major in Portuguese. During this time, she began
          dating one of her friends in the Portuguese program. The two were engaged and got married in August of 2023.
        </p>

        <p>
          Happily married, Tate received her bachelor's degree in Portuguese and continued on to the MAcc program. She
          is set to graduate in December of 2025 and plans to remain at Breeze Airlines as a full-time employee.
        </p>

        <p>
          Although her time at BYU Marriott has been more complicated than she originally anticipated, Tate has
          practiced flexibility and persistence to find ways over and around the obstacles in her life. Her ability to
          work with the people around her to find a way forward is something she hopes will serve her well as she climbs
          the corporate ladder toward her long-term goal of being a CFO.
        </p>
      </PopupLightbox>
      <PopupLightbox trigger={buttonPopup2} setTrigger={setButtonPopup2} columnPosition="colB">
        <h3>Masahiro Hokazono</h3>
        <h4 className="headingSpacer">Adaptation, Ambition, and Accounting</h4>
        <p>
          When Masahiro Hokazono told his mother he planned to go to college in the United States, he couldn't speak
          English at all. So, while taking his first year of classes at a university in Japan, he spent hours studying
          English. Now he has a full-time position at a Big Four firm in Chicago.
        </p>
        <p>
          While Hokazono was honing his English skills, he decided to change his area of study from sociology, because
          he felt it would be difficult to keep up with native English speakers in that field. He began exploring
          number-related careers, since he knew his knowledge of math would translate in any language.
        </p>
        <p>
          After taking an accounting class through Ensign College, Hokazono saw an opportunity to excel in the field of
          accounting, and he was later accepted into Brigham Young University and the School of Accountancy (SOA) at the
          BYU Marriott School of Business.
        </p>
        <p>
          He studied The Church of Jesus Christ of Latter-day Saints as part of his preparations to come to BYU. “I have
          some Japanese friends who are members who I talked to, and I talked with missionaries and to the people at
          Ensign College,” he says. They supplied him with children's books that covered the Church's history and some
          of its beliefs.{" "}
        </p>
        <p>
          “A lot of people are not religious in Japan, and the people who are religious are mostly Shinto, so I didn't
          really understand Christianity and having one god,” Hokazono explains. “Even though I'm not a member of the
          Church, I knew I needed to understand the people and the culture here.”
        </p>
        <p>
          Hokazono's research helped him adjust when he came to BYU. He says although some classes had assignments
          related to church topics, he could often speak with his professors and complete an alternate assignment. “I
          don't think there are many students at BYU who are not members,” he reflects. “But I've had a good education
          even though I'm not a member.”
        </p>
        <p>
          He attributes this success to his ability to adapt. Hokazono says, “One of my strengths is adaptation:
          Usually, I don't do well on the first exam [in a class], but on the second exam, I do well because I study the
          pattern and adapt to that system. That's what I've been doing since I came to the US.”{" "}
        </p>
        <p>
          The SOA's junior core pushed him to adapt the way he approached his education. “During my junior core, I felt
          a huge boundary between my skill and the skills of the top-level students—no matter how much I studied, I
          couldn't catch up,” Hokazono says. “I had to find a new way of thinking toward my life, so I expanded my
          abilities to include more skills, instead of focusing on one thing.”
        </p>
        <p>
          In the junior core, his professors recommended that he take as few classes as possible, but Hokazono enrolled
          in a statistics class to give him a broader base knowledge of business analytics. He has also been taking
          Spanish classes to increase his versatility.
        </p>
        <p>
          “There are so many people who can speak English and can do well on accounting—there are less people who can
          speak English and Japanese and do accounting,” Hokazono explains. “If I can speak Spanish, then there's going
          to be even less people who can do the same things.” He hopes that learning a wider variety of skills will help
          him stand out as a professional.
        </p>
        <p>
          This strategy has already borne fruits for Hokazono. During the summers of 2023 and 2024, he completed an
          internship at KPMG. He says, “KPMG has several offices in Japan, so they're looking for people who can speak
          both Japanese and English.”
        </p>
        <p>
          In January 2025 after completing his bachelor's degree in accounting, Hokazono started working full-time at
          KPMG's office in Chicago. He says, “My journey for now is to become a rare person, so people start needing me
          more—if there are more people who need me, then there are more people I can help.”
        </p>
      </PopupLightbox>
    </div>
  );
};

export default StudentHighlights;
